import { render, staticRenderFns } from "./AyudaMenu.vue?vue&type=template&id=317e74e8&scoped=true&"
import script from "./AyudaMenu.vue?vue&type=script&lang=js&"
export * from "./AyudaMenu.vue?vue&type=script&lang=js&"
import style0 from "./AyudaMenu.vue?vue&type=style&index=0&id=317e74e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317e74e8",
  null
  
)

export default component.exports